import React, { Component, Fragment } from 'react';
import { BreadCrumb, Card } from '../../components';
import { Translate, LanguageConsumer } from '../../contexts/LanguageContext';
import Dropzone from 'react-dropzone';
import { Loading } from '../../components';
import { Config, GetUserToken } from "../../helpers/Config";
import SweetAlert from 'react-bootstrap-sweetalert';
import { DocumentService } from '../../services/DocumentService';

const documentImage = {
    borderRadius: '50px',
    marginBottom: '30px',
    boxShadow: '0 5px 15px 5px rgba(0,0,0,.1)',
    WebkitBoxShadow: '0 5px 15px 5px rgba(0,0,0,.1)',
    marginTop: '30px'
}

export class MyDocuments extends Component {
    constructor() {
        super()
        this.state = {
            filesPhotoId: [],
            filesPOR: [],
            progress: 0,
            loading: true,
            documents: {
                identityAvaible: false,
                residenceAvaible: false,
                files: [],
                file: null
            }
        }

        this.onPhotoDelete = this.onPhotoDelete.bind(this);
        this.onPhotoDrop = this.onPhotoDrop.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }
    onPhotoDrop(files, fileKey) {

        let tempFiles = this.state[fileKey];
        if(tempFiles.length < 2){
            tempFiles.push(files)
            this.setState({ [fileKey]: tempFiles, progress: 0, alert: false });
        }      
    }
    onPhotoDelete(e, id, fileKey) {

        let tempFiles = this.state[fileKey].filter((item, index) => index !== id).map(item => item);

        this.setState({
            [fileKey]: tempFiles,
            alert: false
        });

        e.preventDefault();
    }
    componentWillMount() {
        DocumentService.GetDocuments().then(response => {
            this.setState({
                documents: response,
                loading: false
            });
        });

    }
    componentDidMount() {
        // this.setState({
        //     loading: false
        // })
    }

    uploadFile() {

        if (this.state.filesPhotoId.length === 0 && this.state.filesPOR.length === 0) {
            this.setState({ selectFile: true });
            return false;
        }

        const data = new FormData();

        let files = this.state.filesPhotoId;

        // data.append('Files', files.map(item => (item[0])));


        for (var i = 0; i < files.length; i++) {
            data.append('Identity', files[i][0]);
        }

        let filesPOR = this.state.filesPOR;

        // data.append('FilesPOR', filesPOR.map(item => (item[0])));

        for (var k = 0; k < filesPOR.length; k++) {
            data.append('Residence', filesPOR[k][0]);
        }

        const xhr = new XMLHttpRequest();

        xhr.open("POST", Config.service.document.upload, true);

        xhr.upload.onprogress = (e) => {
            let percentComplete = Math.ceil((e.loaded / e.total) * 100);
            this.setState({
                progress: percentComplete,
            });
        }

        this.setState({
            progress: 0,
            loading: true
        })

        xhr.setRequestHeader('Authorization', 'Bearer ' + GetUserToken());
        xhr.send(data);

        xhr.onload = () => {
            if (xhr.status === 200) {
                this.setState({
                    loading: false,
                    filesPhotoId: [],
                    filesPOR: []
                })
            }
        }

    }

    render() {
        const filesPhotoId = this.state.filesPhotoId.map((file, index) => (
            <li key={file[0].name}>
                {file[0].name} - {file[0].size} bytes  <i className="fas fa-trash-alt ml-2 text-danger drop-zone-delete" onClick={(e) => this.onPhotoDelete(e, index, "filesPhotoId")}></i>
            </li>
        ))

        const filesPOR = this.state.filesPOR.map((file, index) => (
            <li key={file[0].name}>
                {file[0].name} - {file[0].size} bytes  <i className="fas fa-trash-alt ml-2 text-danger drop-zone-delete" onClick={(e) => this.onPhotoDelete(e, index, "filesPOR")}></i>
            </li>
        ))

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" Description={Translate("Your files are uploading, please wait...")} Progress={this.state.progress} />
                        <BreadCrumb Title={Translate('My Documents')} Name={Translate('My Documents')} />
                        <Card>
                            <div className="row tra-my__documents">
                                <div className="col-md-5">
                                    <h4 className="mt-0 header-title">{Translate('Upload Photo Id')}</h4>
                                    {this.state.documents.identityAvaible ?
                                        <div>
                                            <p className="text-muted m-b-30">{Translate('Please verify your identity')}</p>
                                            <div>
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('Valid Passport')}</p>
                                                    </li>
                                                    <li><p className="text-muted"><em>OR</em></p></li>
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('Valid Government ID, such as Drivers License or State ID')}</p>
                                                    </li>
                                                    <li><p className="text-muted"><em>OR</em></p></li>
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('Valid National Identity Card')}</p>
                                                    </li>
                                                </ul>
                                                <div className="alert alert-light mt-4" role="alert"><em>{Translate('All photo ID documents must be valid and clearly show your full name, date of birth and issue/expiry date.')}</em></div>
                                                <div className="alert alert-info mt-4 pr-4" role="alert"><em>{Translate('Document size must be less than 6 mb')}</em></div>                                               
                                                <section>
                                                    <Dropzone onDrop={(files) => this.onPhotoDrop(files, "filesPhotoId")} accept="image/*, application/pdf" multiple={false} >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div {...getRootProps()} className="my_drop rounded drop-zone">
                                                                <input {...getInputProps()} />
                                                                <p>{Translate("Drop files here, or click to select files")}</p>
                                                                <aside>
                                                                    <h4>{Translate("Files")}</h4>
                                                                    <ul>{filesPhotoId}</ul>
                                                                </aside>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </section>
                                            </div>
                                        </div> : this.state.documents.files.map((item, index) => {
                                            if (item.type === "IDENTITY")
                                                return (<div className="img-wrapper text-center" key={index}>
                                                    <img className="img-fluid" style={documentImage} src={"data:" + item.image.contentType + ";base64," + item.image.fileContents} alt="" />
                                                    {item.status ?
                                                        <div className="row">
                                                            <div className="col-md-4"></div>
                                                            <div className="col-md-4 alert alert-success mt-2">
                                                                {Translate("Approved")}
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="tra-alert__wrapper">
                                                            <div className="alert alert-warning mt-2">
                                                                {Translate("Pending")}
                                                            </div>
                                                        </div>}

                                                </div>
                                                )
                                            else return ("");
                                        }
                                        )}

                                </div>
                                <div className="col-md-2 text-center">
                                    <div className="tra-verify__wrapper">
                                        <img src="assets/images/verify-account.svg" className="verify-icon" alt="Verify" />                                        
                                    </div>
                                    <div className="tra-upload__button">
                                    <button type="button" className="btn btn-primary btn-lg" onClick={this.uploadFile}><i className="fas fa-upload mr-1"></i>{Translate('Upload My Documents')}</button>
                                    {this.state.selectFile ?
                                        <SweetAlert
                                            title="Error?"
                                            warning
                                            onConfirm={() => this.setState({ selectFile: false })} >
                                            You should drop any file!
                                    </SweetAlert> : null}
                                </div>
                                </div>
                                <div className="col-md-5">
                                    {this.state.documents.residenceAvaible ?
                                        <div>
                                            <h4 className="mt-0 header-title">{Translate('Upload Proof of Residence')}</h4>
                                            <p className="text-muted m-b-30">{Translate('Please upload your proof of residence')}</p>
                                            <div>
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('Utility, Phone, Internet Bills')}</p>
                                                    </li>
                                                    <li><p className="text-muted"><em>{Translate('OR')}</em></p></li>
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('Bank Statement')}</p>
                                                    </li>
                                                    <li><p className="text-muted"><em>{Translate('OR')}</em></p></li>
                                                    <li>
                                                        <p><i className="fas fa-check p-2 bg-success rounded text-white font-12 mr-2"></i>{Translate('E-state place of residence')}</p>
                                                    </li>
                                                </ul>
                                                <div className="alert alert-light mt-4 pr-4" role="alert"><em>{Translate('All proof of residences must be current, show the full document, clearly display the name and address, and show a provision of services such as money owed or paid.')}</em></div>
                                                <div className="alert alert-info mt-4 pr-4" role="alert"><em>{Translate('Document size must be less than 6 mb')}</em></div>
                                                <section>
                                                    <Dropzone onDrop={(files) => this.onPhotoDrop(files, "filesPOR")} accept="image/*, application/pdf" >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div {...getRootProps()} className="my_drop rounded drop-zone">
                                                                <input {...getInputProps()} />
                                                                <p>{Translate('Drop files here, or click to select files')}</p>
                                                                <aside>
                                                                    <h4>{Translate('Files')}</h4>
                                                                    <ul>{filesPOR}</ul>
                                                                </aside>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </section>
                                            </div>
                                        </div>
                                        : this.state.documents.files.map((item, index) => {
                                            if (item.type === "RESIDENCE")
                                                return (<div className="img-wrapper mt-4 text-center" key={index}>
                                                    <img className="img-fluid" style={documentImage} src={"data:" + item.image.contentType + ";base64," + item.image.fileContents} alt="" />
                                                    {item.status ?
                                                        <div className="row">
                                                            <div className="col-md-4"></div>
                                                            <div className="col-md-4 alert alert-success mt-2">
                                                                {Translate("Approved")}
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="tra-alert__wrapper">
                                                            <div className="alert alert-warning mt-2">
                                                                {Translate("Pending")}
                                                            </div>
                                                        </div>}                                                       
                                                </div>
                                                )
                                                else return("")
                                        }
                                        )}
                                </div>
                            </div>
                        </Card>
                    </Fragment>

                )}
            </LanguageConsumer>

        )
    }
}